import React from 'react';

// Constellation
import {
  Button,
  Collapsible,
  // @ts-expect-error
  Dropdown,
  IconChevronDown,
  IconChevronUp,
  Text,
} from '@zillow/constellation';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Styles
import * as S from './styles';

/**
 * FilterWrapper wraps each filter popover with Popper logic (desktop), header styling,
 * done button (desktop), possible Collapsible header (mWeb), and other styles.
 *
 * Note: in order for the Dropdown to function properly, filter components must return
 * FilterWrapper called functionally - ex: FilterWrapper({ heading, children })
 */
const FilterWrapper = ({
  children,
  heading,
  useCollapse,
}: {
  children: React.ReactNode;
  heading: string | React.ReactNode;
  useCollapse?: boolean;
}) => {
  const isMobile: boolean = useAppSelector((state) => state.app.device.isMobile);
  const isMdScreen = useAppSelector((state) => state.app.device.screenWidth) === 'md';
  const isMobileOrTablet = isMobile || isMdScreen;

  const renderDesktopWrapper = (
    <Dropdown>
      {({ onClose }: { onClose: () => void }) => (
        <S.Container>
          <Text fontType="bodyHeading" as="h5" marginLeft="md" marginTop="sm">
            {heading}
          </Text>
          {children}
          <S.DoneContainer>
            <Button size="sm" onClick={onClose}>
              Done
            </Button>
          </S.DoneContainer>
        </S.Container>
      )}
    </Dropdown>
  );

  const renderMobileWrapper = (
    <S.Container>
      <Text fontType="bodyHeading" as="h5" marginLeft="md" marginTop="md">
        {heading}
      </Text>
      {children}
    </S.Container>
  );

  const renderMobileWrapperWithCollapse = (
    <S.Container>
      <Collapsible
        /* eslint-disable react/no-children-prop */
        children={(collapsed: boolean, toggle: () => void) => (
          /* eslint-enable */
          <S.CollapsibleWrapperContainer>
            {heading}
            <S.ChevronContainer onClick={toggle}>
              {collapsed ? (
                <IconChevronDown fontColor="brand" size="sm" />
              ) : (
                <IconChevronUp fontColor="brand" size="sm" />
              )}
            </S.ChevronContainer>
            {collapsed ? null : children}
          </S.CollapsibleWrapperContainer>
        )}
      />
    </S.Container>
  );

  return isMobileOrTablet
    ? useCollapse
      ? renderMobileWrapperWithCollapse
      : renderMobileWrapper
    : renderDesktopWrapper;
};

export default FilterWrapper;
